<kz-modal-content>
  <h1 class="kz-light-title" i18n="@@optinRemind.title">Don't miss out!</h1>

  <div class="description" i18n="@@optinRemind.description">We are preparing weekly emails with offers and promotions specially selected for you from Kozikaza partners.<br/><br/>
    <strong>We'd be sad if you missed out on your dream kitchen when it was within reach!</strong><br/><br/>
    Relevant information that might interest you:
    <ul>
      <li>Enjoy a personalized kazacafé stream</li>
      <li>Stay informed about the latest partner offers related to your project</li>
      <li>Benefit from personalized promo codes</li>
      <li>Tips and tricks related to your project</li>
      <li>Coaching services or project-related planning assistance</li>
    </ul>
  </div>

  <div class="not-spamming" i18n="@@optinRemind.notSpamming">We don't spam, and unsubscribing is possible at any time.</div>

  <div class="kz-field-buttons">
    <button type="button" kzButton (click)="save(false)" buttonStyle="borderless" i18n="@@optinRemind.button.noThanks" [disabled]="submitted">No, thanks</button>
    <button type="submit" kzButton (click)="save(true)" buttonStyle="flat" [buttonState]="'default'" [disabled]="submitted" data-cy="submit"><span i18n="@@optinRemind.button.accept">I Accept</span></button>
  </div>
</kz-modal-content>

<div class="kz-modal-content-illustration">
  <div class="img-1"></div>
  <div class="img-2"></div>
</div>
